import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { NavHeaderMoreButton } from '@euler/app/components/nav/NavHeaderMoreButton';
import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { useIsIpad } from '@euler/functions/responsiveness';
import { usePersistFn } from '@euler/utils/hooks';
import { useActionSheet } from '@expo/react-native-action-sheet';
import { memo, useRef } from 'react';
import { TouchableOpacity, findNodeHandle } from 'react-native';

type Action = {
  type: 'rollback' | 'create-order' | 'cancel';
  name: string;
};

export const HeaderRight = memo(() => {
  const navigation = useAppNavigation();

  const { serviceRecord, canRollback } = useServiceRecordContext();

  const { showActionSheetWithOptions } = useActionSheet();
  const { rollback } = useServiceRecordContext();

  const buttonRef = useRef<TouchableOpacity>(null);
  const isIpad = useIsIpad();

  const onPress = usePersistFn(() => {
    let nodeId: number | null = null;
    if (isIpad && buttonRef?.current != null) {
      nodeId = findNodeHandle(buttonRef.current);
    }

    const actions: Action[] = [{ type: 'create-order', name: '快捷开单' }];
    if (canRollback) {
      actions.push({ type: 'rollback', name: '返单' });
    }
    actions.push({ type: 'cancel', name: '关闭' });

    showActionSheetWithOptions(
      {
        options: actions.map(x => x.name),
        anchor: nodeId ?? undefined,
        destructiveButtonIndex: canRollback
          ? actions.findIndex(x => x.type === 'rollback')
          : undefined,
        cancelButtonIndex: actions.length - 1,
      },
      async index => {
        if (index == null || index < 0) return;
        const action = actions[index];
        if (action == null) return;
        if (action.type === 'rollback') {
          await rollback();
        } else if (action.type === 'create-order') {
          navigation.push('_order', {
            mode: 'new',
            type: 'main',
            defaultValues: {
              licensePlateNo: serviceRecord.licensePlateNo,
              vin: serviceRecord.vin,
              vehicleInfo: {
                vehicleName: serviceRecord.vehicleName,
                vehicleImageUrl: serviceRecord.vehicleImageUrl ?? undefined,
                vehicleBrandName: serviceRecord.vehicleBrand,
                vehicleBrandLogo: serviceRecord.vehicleBrandLogo ?? undefined,
                vehicleManufacturer:
                  serviceRecord.vehicleManufacturer ?? undefined,
                vehicleFuelType: serviceRecord.vehicleFuelType ?? undefined,
                vehicleModel: serviceRecord.vehicleModel ?? undefined,
                vehicleModelYear: serviceRecord.vehicleModelYear ?? undefined,
                vehicleDisplacement:
                  serviceRecord.vehicleDisplacement ?? undefined,
                vehicleTrimLevel: serviceRecord.vehicleTrimLevel ?? undefined,
              },
            },
          });
        }
      },
    );
  });

  return <NavHeaderMoreButton ref={buttonRef} onPress={onPress} color="#fff" />;
});
